import React, { FC } from 'react';
import classnames from 'classnames';

import { IProductLabel } from 'api/types';

import styles from 'theme/components/wise/WiseLabel/WiseLabel.module.scss';

interface IProps {
  label: IProductLabel;
}

/** Etykieta produktu (Wise) - wariant wizualny dla redesignu; logika jak `Label`. */
const WiseLabel: FC<IProps> = ({ label }) => (
  <span
    className={classnames(
      styles.componentWrapper,
      styles[label.type.toLowerCase()],
      'StylePath-Components-Wise-WiseLabel'
    )}>
    {label.name}
  </span>
);

export default WiseLabel;
